/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AccessDeniedRouteImport } from './routes/access-denied'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as AdminIndexRouteImport } from './routes/_admin/index'
import { Route as AdminDashboardRouteImport } from './routes/_admin/dashboard'
import { Route as AdminUsersIndexRouteImport } from './routes/_admin/users/index'
import { Route as AdminTemporaryDevicesIndexRouteImport } from './routes/_admin/temporary-devices/index'
import { Route as AdminPermitsIndexRouteImport } from './routes/_admin/permits/index'
import { Route as AdminParametersIndexRouteImport } from './routes/_admin/parameters/index'
import { Route as AdminOrgsIndexRouteImport } from './routes/_admin/orgs/index'
import { Route as AdminEmailsIndexRouteImport } from './routes/_admin/emails/index'
import { Route as AdminDeviceInstallationsIndexRouteImport } from './routes/_admin/device-installations/index'
import { Route as AdminCategoricalStandardsIndexRouteImport } from './routes/_admin/categorical-standards/index'
import { Route as AdminAuditLogsIndexRouteImport } from './routes/_admin/audit-logs/index'
import { Route as AdminAnalyticsIndexRouteImport } from './routes/_admin/analytics/index'
import { Route as AdminAccountsIndexRouteImport } from './routes/_admin/accounts/index'
import { Route as AdminUsersUserIdRouteImport } from './routes/_admin/users/$userId'
import { Route as AdminTemporaryDevicesIdRouteImport } from './routes/_admin/temporary-devices/$id'
import { Route as AdminPermitsPermitIdRouteImport } from './routes/_admin/permits/$permitId'
import { Route as AdminOrgsOrgIdRouteImport } from './routes/_admin/orgs/$orgId'
import { Route as AdminEmailsEmailIdRouteImport } from './routes/_admin/emails/$emailId'
import { Route as AdminDeviceInstallationsIdRouteImport } from './routes/_admin/device-installations/$id'
import { Route as AdminAnalyticsEventsRouteImport } from './routes/_admin/analytics/events'
import { Route as AdminAccountsIdRouteImport } from './routes/_admin/accounts/$id'
import { Route as AdminParametersOrgsOrgIdRouteImport } from './routes/_admin/parameters/orgs.$orgId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessDeniedRoute = AccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTemporaryDevicesIndexRoute =
  AdminTemporaryDevicesIndexRouteImport.update({
    id: '/temporary-devices/',
    path: '/temporary-devices/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminPermitsIndexRoute = AdminPermitsIndexRouteImport.update({
  id: '/permits/',
  path: '/permits/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminParametersIndexRoute = AdminParametersIndexRouteImport.update({
  id: '/parameters/',
  path: '/parameters/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrgsIndexRoute = AdminOrgsIndexRouteImport.update({
  id: '/orgs/',
  path: '/orgs/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEmailsIndexRoute = AdminEmailsIndexRouteImport.update({
  id: '/emails/',
  path: '/emails/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDeviceInstallationsIndexRoute =
  AdminDeviceInstallationsIndexRouteImport.update({
    id: '/device-installations/',
    path: '/device-installations/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCategoricalStandardsIndexRoute =
  AdminCategoricalStandardsIndexRouteImport.update({
    id: '/categorical-standards/',
    path: '/categorical-standards/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAuditLogsIndexRoute = AdminAuditLogsIndexRouteImport.update({
  id: '/audit-logs/',
  path: '/audit-logs/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsIndexRoute = AdminAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAccountsIndexRoute = AdminAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTemporaryDevicesIdRoute = AdminTemporaryDevicesIdRouteImport.update({
  id: '/temporary-devices/$id',
  path: '/temporary-devices/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPermitsPermitIdRoute = AdminPermitsPermitIdRouteImport.update({
  id: '/permits/$permitId',
  path: '/permits/$permitId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrgsOrgIdRoute = AdminOrgsOrgIdRouteImport.update({
  id: '/orgs/$orgId',
  path: '/orgs/$orgId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEmailsEmailIdRoute = AdminEmailsEmailIdRouteImport.update({
  id: '/emails/$emailId',
  path: '/emails/$emailId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDeviceInstallationsIdRoute =
  AdminDeviceInstallationsIdRouteImport.update({
    id: '/device-installations/$id',
    path: '/device-installations/$id',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAnalyticsEventsRoute = AdminAnalyticsEventsRouteImport.update({
  id: '/analytics/events',
  path: '/analytics/events',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAccountsIdRoute = AdminAccountsIdRouteImport.update({
  id: '/accounts/$id',
  path: '/accounts/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminParametersOrgsOrgIdRoute =
  AdminParametersOrgsOrgIdRouteImport.update({
    id: '/parameters/orgs/$orgId',
    path: '/parameters/orgs/$orgId',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AdminIndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AdminDashboardRoute
  '/accounts/$id': typeof AdminAccountsIdRoute
  '/analytics/events': typeof AdminAnalyticsEventsRoute
  '/device-installations/$id': typeof AdminDeviceInstallationsIdRoute
  '/emails/$emailId': typeof AdminEmailsEmailIdRoute
  '/orgs/$orgId': typeof AdminOrgsOrgIdRoute
  '/permits/$permitId': typeof AdminPermitsPermitIdRoute
  '/temporary-devices/$id': typeof AdminTemporaryDevicesIdRoute
  '/users/$userId': typeof AdminUsersUserIdRoute
  '/accounts/': typeof AdminAccountsIndexRoute
  '/analytics/': typeof AdminAnalyticsIndexRoute
  '/audit-logs/': typeof AdminAuditLogsIndexRoute
  '/categorical-standards/': typeof AdminCategoricalStandardsIndexRoute
  '/device-installations/': typeof AdminDeviceInstallationsIndexRoute
  '/emails/': typeof AdminEmailsIndexRoute
  '/orgs/': typeof AdminOrgsIndexRoute
  '/parameters/': typeof AdminParametersIndexRoute
  '/permits/': typeof AdminPermitsIndexRoute
  '/temporary-devices/': typeof AdminTemporaryDevicesIndexRoute
  '/users/': typeof AdminUsersIndexRoute
  '/parameters/orgs/$orgId': typeof AdminParametersOrgsOrgIdRoute
}
export interface FileRoutesByTo {
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AdminDashboardRoute
  '/': typeof AdminIndexRoute
  '/accounts/$id': typeof AdminAccountsIdRoute
  '/analytics/events': typeof AdminAnalyticsEventsRoute
  '/device-installations/$id': typeof AdminDeviceInstallationsIdRoute
  '/emails/$emailId': typeof AdminEmailsEmailIdRoute
  '/orgs/$orgId': typeof AdminOrgsOrgIdRoute
  '/permits/$permitId': typeof AdminPermitsPermitIdRoute
  '/temporary-devices/$id': typeof AdminTemporaryDevicesIdRoute
  '/users/$userId': typeof AdminUsersUserIdRoute
  '/accounts': typeof AdminAccountsIndexRoute
  '/analytics': typeof AdminAnalyticsIndexRoute
  '/audit-logs': typeof AdminAuditLogsIndexRoute
  '/categorical-standards': typeof AdminCategoricalStandardsIndexRoute
  '/device-installations': typeof AdminDeviceInstallationsIndexRoute
  '/emails': typeof AdminEmailsIndexRoute
  '/orgs': typeof AdminOrgsIndexRoute
  '/parameters': typeof AdminParametersIndexRoute
  '/permits': typeof AdminPermitsIndexRoute
  '/temporary-devices': typeof AdminTemporaryDevicesIndexRoute
  '/users': typeof AdminUsersIndexRoute
  '/parameters/orgs/$orgId': typeof AdminParametersOrgsOrgIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_admin': typeof AdminRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/_admin/dashboard': typeof AdminDashboardRoute
  '/_admin/': typeof AdminIndexRoute
  '/_admin/accounts/$id': typeof AdminAccountsIdRoute
  '/_admin/analytics/events': typeof AdminAnalyticsEventsRoute
  '/_admin/device-installations/$id': typeof AdminDeviceInstallationsIdRoute
  '/_admin/emails/$emailId': typeof AdminEmailsEmailIdRoute
  '/_admin/orgs/$orgId': typeof AdminOrgsOrgIdRoute
  '/_admin/permits/$permitId': typeof AdminPermitsPermitIdRoute
  '/_admin/temporary-devices/$id': typeof AdminTemporaryDevicesIdRoute
  '/_admin/users/$userId': typeof AdminUsersUserIdRoute
  '/_admin/accounts/': typeof AdminAccountsIndexRoute
  '/_admin/analytics/': typeof AdminAnalyticsIndexRoute
  '/_admin/audit-logs/': typeof AdminAuditLogsIndexRoute
  '/_admin/categorical-standards/': typeof AdminCategoricalStandardsIndexRoute
  '/_admin/device-installations/': typeof AdminDeviceInstallationsIndexRoute
  '/_admin/emails/': typeof AdminEmailsIndexRoute
  '/_admin/orgs/': typeof AdminOrgsIndexRoute
  '/_admin/parameters/': typeof AdminParametersIndexRoute
  '/_admin/permits/': typeof AdminPermitsIndexRoute
  '/_admin/temporary-devices/': typeof AdminTemporaryDevicesIndexRoute
  '/_admin/users/': typeof AdminUsersIndexRoute
  '/_admin/parameters/orgs/$orgId': typeof AdminParametersOrgsOrgIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/access-denied'
    | '/login'
    | '/dashboard'
    | '/accounts/$id'
    | '/analytics/events'
    | '/device-installations/$id'
    | '/emails/$emailId'
    | '/orgs/$orgId'
    | '/permits/$permitId'
    | '/temporary-devices/$id'
    | '/users/$userId'
    | '/accounts/'
    | '/analytics/'
    | '/audit-logs/'
    | '/categorical-standards/'
    | '/device-installations/'
    | '/emails/'
    | '/orgs/'
    | '/parameters/'
    | '/permits/'
    | '/temporary-devices/'
    | '/users/'
    | '/parameters/orgs/$orgId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/access-denied'
    | '/login'
    | '/dashboard'
    | '/'
    | '/accounts/$id'
    | '/analytics/events'
    | '/device-installations/$id'
    | '/emails/$emailId'
    | '/orgs/$orgId'
    | '/permits/$permitId'
    | '/temporary-devices/$id'
    | '/users/$userId'
    | '/accounts'
    | '/analytics'
    | '/audit-logs'
    | '/categorical-standards'
    | '/device-installations'
    | '/emails'
    | '/orgs'
    | '/parameters'
    | '/permits'
    | '/temporary-devices'
    | '/users'
    | '/parameters/orgs/$orgId'
  id:
    | '__root__'
    | '/_admin'
    | '/access-denied'
    | '/login'
    | '/_admin/dashboard'
    | '/_admin/'
    | '/_admin/accounts/$id'
    | '/_admin/analytics/events'
    | '/_admin/device-installations/$id'
    | '/_admin/emails/$emailId'
    | '/_admin/orgs/$orgId'
    | '/_admin/permits/$permitId'
    | '/_admin/temporary-devices/$id'
    | '/_admin/users/$userId'
    | '/_admin/accounts/'
    | '/_admin/analytics/'
    | '/_admin/audit-logs/'
    | '/_admin/categorical-standards/'
    | '/_admin/device-installations/'
    | '/_admin/emails/'
    | '/_admin/orgs/'
    | '/_admin/parameters/'
    | '/_admin/permits/'
    | '/_admin/temporary-devices/'
    | '/_admin/users/'
    | '/_admin/parameters/orgs/$orgId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminRoute: typeof AdminRouteWithChildren
  AccessDeniedRoute: typeof AccessDeniedRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/': {
      id: '/_admin/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/dashboard': {
      id: '/_admin/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users/': {
      id: '/_admin/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/temporary-devices/': {
      id: '/_admin/temporary-devices/'
      path: '/temporary-devices'
      fullPath: '/temporary-devices/'
      preLoaderRoute: typeof AdminTemporaryDevicesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/permits/': {
      id: '/_admin/permits/'
      path: '/permits'
      fullPath: '/permits/'
      preLoaderRoute: typeof AdminPermitsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/parameters/': {
      id: '/_admin/parameters/'
      path: '/parameters'
      fullPath: '/parameters/'
      preLoaderRoute: typeof AdminParametersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/orgs/': {
      id: '/_admin/orgs/'
      path: '/orgs'
      fullPath: '/orgs/'
      preLoaderRoute: typeof AdminOrgsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/emails/': {
      id: '/_admin/emails/'
      path: '/emails'
      fullPath: '/emails/'
      preLoaderRoute: typeof AdminEmailsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/device-installations/': {
      id: '/_admin/device-installations/'
      path: '/device-installations'
      fullPath: '/device-installations/'
      preLoaderRoute: typeof AdminDeviceInstallationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/categorical-standards/': {
      id: '/_admin/categorical-standards/'
      path: '/categorical-standards'
      fullPath: '/categorical-standards/'
      preLoaderRoute: typeof AdminCategoricalStandardsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/audit-logs/': {
      id: '/_admin/audit-logs/'
      path: '/audit-logs'
      fullPath: '/audit-logs/'
      preLoaderRoute: typeof AdminAuditLogsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/analytics/': {
      id: '/_admin/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AdminAnalyticsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/accounts/': {
      id: '/_admin/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AdminAccountsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users/$userId': {
      id: '/_admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/temporary-devices/$id': {
      id: '/_admin/temporary-devices/$id'
      path: '/temporary-devices/$id'
      fullPath: '/temporary-devices/$id'
      preLoaderRoute: typeof AdminTemporaryDevicesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/permits/$permitId': {
      id: '/_admin/permits/$permitId'
      path: '/permits/$permitId'
      fullPath: '/permits/$permitId'
      preLoaderRoute: typeof AdminPermitsPermitIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/orgs/$orgId': {
      id: '/_admin/orgs/$orgId'
      path: '/orgs/$orgId'
      fullPath: '/orgs/$orgId'
      preLoaderRoute: typeof AdminOrgsOrgIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/emails/$emailId': {
      id: '/_admin/emails/$emailId'
      path: '/emails/$emailId'
      fullPath: '/emails/$emailId'
      preLoaderRoute: typeof AdminEmailsEmailIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/device-installations/$id': {
      id: '/_admin/device-installations/$id'
      path: '/device-installations/$id'
      fullPath: '/device-installations/$id'
      preLoaderRoute: typeof AdminDeviceInstallationsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/analytics/events': {
      id: '/_admin/analytics/events'
      path: '/analytics/events'
      fullPath: '/analytics/events'
      preLoaderRoute: typeof AdminAnalyticsEventsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/accounts/$id': {
      id: '/_admin/accounts/$id'
      path: '/accounts/$id'
      fullPath: '/accounts/$id'
      preLoaderRoute: typeof AdminAccountsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/parameters/orgs/$orgId': {
      id: '/_admin/parameters/orgs/$orgId'
      path: '/parameters/orgs/$orgId'
      fullPath: '/parameters/orgs/$orgId'
      preLoaderRoute: typeof AdminParametersOrgsOrgIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminAccountsIdRoute: typeof AdminAccountsIdRoute
  AdminAnalyticsEventsRoute: typeof AdminAnalyticsEventsRoute
  AdminDeviceInstallationsIdRoute: typeof AdminDeviceInstallationsIdRoute
  AdminEmailsEmailIdRoute: typeof AdminEmailsEmailIdRoute
  AdminOrgsOrgIdRoute: typeof AdminOrgsOrgIdRoute
  AdminPermitsPermitIdRoute: typeof AdminPermitsPermitIdRoute
  AdminTemporaryDevicesIdRoute: typeof AdminTemporaryDevicesIdRoute
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
  AdminAccountsIndexRoute: typeof AdminAccountsIndexRoute
  AdminAnalyticsIndexRoute: typeof AdminAnalyticsIndexRoute
  AdminAuditLogsIndexRoute: typeof AdminAuditLogsIndexRoute
  AdminCategoricalStandardsIndexRoute: typeof AdminCategoricalStandardsIndexRoute
  AdminDeviceInstallationsIndexRoute: typeof AdminDeviceInstallationsIndexRoute
  AdminEmailsIndexRoute: typeof AdminEmailsIndexRoute
  AdminOrgsIndexRoute: typeof AdminOrgsIndexRoute
  AdminParametersIndexRoute: typeof AdminParametersIndexRoute
  AdminPermitsIndexRoute: typeof AdminPermitsIndexRoute
  AdminTemporaryDevicesIndexRoute: typeof AdminTemporaryDevicesIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminParametersOrgsOrgIdRoute: typeof AdminParametersOrgsOrgIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminDashboardRoute: AdminDashboardRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminAccountsIdRoute: AdminAccountsIdRoute,
  AdminAnalyticsEventsRoute: AdminAnalyticsEventsRoute,
  AdminDeviceInstallationsIdRoute: AdminDeviceInstallationsIdRoute,
  AdminEmailsEmailIdRoute: AdminEmailsEmailIdRoute,
  AdminOrgsOrgIdRoute: AdminOrgsOrgIdRoute,
  AdminPermitsPermitIdRoute: AdminPermitsPermitIdRoute,
  AdminTemporaryDevicesIdRoute: AdminTemporaryDevicesIdRoute,
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
  AdminAccountsIndexRoute: AdminAccountsIndexRoute,
  AdminAnalyticsIndexRoute: AdminAnalyticsIndexRoute,
  AdminAuditLogsIndexRoute: AdminAuditLogsIndexRoute,
  AdminCategoricalStandardsIndexRoute: AdminCategoricalStandardsIndexRoute,
  AdminDeviceInstallationsIndexRoute: AdminDeviceInstallationsIndexRoute,
  AdminEmailsIndexRoute: AdminEmailsIndexRoute,
  AdminOrgsIndexRoute: AdminOrgsIndexRoute,
  AdminParametersIndexRoute: AdminParametersIndexRoute,
  AdminPermitsIndexRoute: AdminPermitsIndexRoute,
  AdminTemporaryDevicesIndexRoute: AdminTemporaryDevicesIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminParametersOrgsOrgIdRoute: AdminParametersOrgsOrgIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AdminRoute: AdminRouteWithChildren,
  AccessDeniedRoute: AccessDeniedRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
